module.exports = {
    NOT_LOADED: 1,
    LOADING:2,
    LOADED: 3,
    CAUSED_ERROR: 4,
}